import { GeminiClient } from "./base/GeminiClient";
import { PromptBuilders } from "./utils/PromptBuilders";
import { ResponseParsers } from "./utils/ResponseParsers";
import type {
  GenerateMilestonesRequest,
  GenerateMilestonesResponse,
} from "@/features/Projects";

export class MilestonesService extends GeminiClient {
  async generateMilestones(
    request: GenerateMilestonesRequest
  ): Promise<GenerateMilestonesResponse> {
    if (!request.projectDescription?.trim()) {
      throw new Error("Descrição do projeto é obrigatória");
    }

    if (!request.objectives || request.objectives.length === 0) {
      throw new Error("Objetivos do projeto são obrigatórios");
    }

    try {
      const prompt = PromptBuilders.buildMilestonesPrompt(
        request.projectDescription,
        request.objectives,
        request.technicalSolution?.description,
        undefined
      );
      const response = await this.callGeminiAPI(prompt);

      return ResponseParsers.parseMilestonesResponse(response);
    } catch (error) {
      console.error("Erro ao gerar milestones:", error);
      throw new Error("Falha ao processar milestones com IA");
    }
  }
}